import { createFileRoute } from "@tanstack/react-router";

import { ProfilePage } from "@/components/profile/ProfilePage";

export const Route = createFileRoute("/profile")({
  head: () => ({
    meta: [
      { title: "Your profile — SyncAni" },
      {
        name: "description",
        content:
          "Pick your name, animal, theme and language for SyncAni rooms.",
      },
      { property: "og:title", content: "Your profile — SyncAni" },
      {
        property: "og:description",
        content:
          "Pick your name, animal, theme and language for SyncAni rooms.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: ProfilePage,
});
